import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { Utilities } from '../../components/Utilities';
import { selectPageType } from '../../selectors/page';
import { IApplicationState } from '../../types/redux';
import { TUserState } from '../../types/user';
import { useIsDailyrentFastFiltersRedesignExpEnabled } from '../../utils/experiments/dailyrentFastFiltersRedesign';
import { UtilityCompareContainer } from '../UtilityCompareContainer';
import { UtilityFavoritesContainer } from '../UtilityFavoritesContainer';
import { UtilityFiltersContainer } from '../UtilityFiltersContainer/UtilityFiltersContainer';
import { UtilityMessagesContainer } from '../UtilityMessagesContainer';
import { UtilityNotificationsContainer } from '../UtilityNotificationsContainer';
import { UtilitySavedSearchesContainer } from '../UtilitySavedSearchesContainer';

export const UtilitiesContainer: React.FC = () => {
  const user = useSelector<IApplicationState, TUserState>(state => state.user);
  const pageType = useSelector(selectPageType);
  const deviceType = useDeviceType();
  const isMobile = ['phone', 'tablet'].includes(deviceType);
  const isDailyRentSearch = pageType === 'searchRentDaily';

  // @todo выпилить эксп https://jira.cian.tech/browse/CD-185110
  // при включенном эксперименте должны показываться обычные контролы, как на всех вертикалях
  const isDailyrentRedesignedFastFiltersExpEnabled = useIsDailyrentFastFiltersRedesignExpEnabled();

  const content =
    isMobile && isDailyRentSearch && !isDailyrentRedesignedFastFiltersExpEnabled ? (
      <UtilityFiltersContainer />
    ) : (
      <>
        <UtilityCompareContainer />
        <UtilityMessagesContainer />
        <UtilityFavoritesContainer />
        {user.isAuthenticated && <UtilitySavedSearchesContainer />}
        <UtilityNotificationsContainer />
      </>
    );

  return <Utilities testId="Utilities">{content}</Utilities>;
};
